<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <b-form-select v-model="form.icareyouth_id" :options="options"></b-form-select>
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="assign_icare(form.uuid,form.icareyouth_id)"  variant="outline" color="info">Update</CButton>
        
        </template>
        <!-- <pre>{{ $data }}</pre> -->
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import satelite from '@/services/satelitechurch'
import icareyouth from '@/services/icareyouth'
import member from '@/services/member';

import moment from 'moment';

export default {
name: 'icaremodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      name:'',
      icareyouth_id:'',
    },
    options:[],
   
    }
  },
  
  mounted (){
    
   },
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_MEMBER_ICARE_YOUTH', (params) => {
      if(params.data){
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.uuid = "";
          self.form.icareyouth_id = "";
          this.form.uuid = params.data;
      }
 
    });
    
    this.options = []
    icareyouth.getIcare()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        //alert
        this.options.push({text: res.data[i].name, value:res.data[i].id})
      }
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    assign_icare(id,icareyouth_id){
      this.show = false;
        if(confirm("Do you really want to assign icare ?")){
          var param = {
            icareyouth_id: icareyouth_id,
          }
          member.assign_icare_youth(id, param)
          .then(res => {
            //this.load()
            EventBus.$emit('TABLE_UPDATE_IKID_GRADUATE', true)
            console.log(id, param)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
      },
  }
}
</script>

<style>

</style>